import React from 'react'
import Alert from '@material-ui/lab/Alert';
function ErrorMessage() {
    return(
        <div>
            <Alert severity="error"> You do not have access to the tool, for access please raise a ticket through: <a href="https://internalsupport.viu.com">https://internalsupport.viu.com</a></Alert>
        </div>
    )
    
}
export default ErrorMessage